import { Accordion2 } from '@looker/components';
import styled from 'styled-components';

export const StyledAnchor = styled.a`
  text-decoration: none;
  color: inherit;
  display: inline-flex;
  margin-right: 4px;
`;

export const StyledAccordion = styled(Accordion2)`
  margin-bottom: 8px;

  & > [role='region'] {
    height: auto;
    overflow: visible;
    padding-left: 20px;
    padding-top: 8px;
  }
`;
